import React from 'react';
import PropTypes from 'prop-types';
import { formatClassName } from '../../Util';
import Button from '../Button';

const Footer = ({ button, buttonClass }) => {
  function renderButtons() {
    if (Array.isArray(button)) {
      return button.map(renderButton);
    } else if (button && button.action) {
      return renderButton(button);
    } else {
      return button;
    }
  }

  function renderButton(button, index) {
    const { icon, label } = button;
    if (!icon && !label) {
      return null;
    }
    return (
      <Button key={index} {...button} onClick={button.action} />
    );
  }

  return (
    <div className={formatClassName(['layout-footer', buttonClass])}>
      {renderButtons()}
    </div>
  );
}

Footer.propTypes = {
  button: PropTypes.oneOfType([
    PropTypes.shape(Button.propTypes),
    PropTypes.arrayOf(PropTypes.shape(Button.propTypes))
  ]),
  buttonClass: PropTypes.string
};

export default Footer;
